<template>
    <div class="layout-aside">
        <el-menu :default-active="activeRoute" router unique-opened class="el-menu-vertical-demo" @select="selectMenu">
          <div v-for="(menuItem,index) in menuList" :key="index">
            <el-submenu :index="menuItem.title"  v-if="menuItem.children && menuItem.children.length > 1">
                <template slot="title">
                    <i :class="menuItem.icon"></i>
                    <span slot="title">{{menuItem.title}}</span>
                </template>
                <el-menu-item-group>
                    <el-menu-item :index="subItem.path" v-for="(subItem,index) in menuItem.children" :key="index">{{subItem.title}}</el-menu-item>
                </el-menu-item-group>
            </el-submenu>
            <div v-else-if="menuItem.children && menuItem.children.length === 1">
                <el-menu-item :index="subItem.path"  v-for="(subItem,index) in menuItem.children" :key="index">
                    <i :class="subItem.icon"></i>
                    <span slot="title">{{subItem.title}}</span>
                </el-menu-item>
            </div>
          </div>
        </el-menu>
    </div>
</template>

<script>
import routesMap from "@/router/routesMap";
import { getRouterMenuList } from "@/assets/js/getRouterMenuList";

export default {
  data() {
    return {
      menuList: [],
      activeRoute: ""
    };
  },
  watch: {
    $route(to, from) {
      this.activeRoute = this.handleRoutes(to.path);
    }
  },
  methods: {
    selectMenu(index, indexPath) {
      this.$root.eventHub.$emit("sideRoutePath", index);
    },
    handleRoutes(route) {
      let path = route;
      if (route == "/super/create_role") {
        path = "/super/role_admin";
      }
      if (route == "/super/add_company") {
        path = "/super/company_admin";
      }
      if (route == "/super/add_shop") {
        path = "/super/shop_admin";
      }
      if (route == "/super/pay_setting") {
        path = "/super/company_admin";
      }
      // 商户
      if (route == "/merchant/mul_add_food") {
        path = "/merchant/food_admin";
      }
      if (route == "/merchant/face_account_detail") {
        path = "/merchant/face_account";
      }
      if (route == "/merchant/create_role") {
        path = "/merchant/role_admin";
      }
      if (route == "/merchant/add_shop") {
        path = "/merchant/shop_admin";
      }
      // 食堂
      if (route == "/shop/create_role") {
        path = "/shop/role_admin";
      }
      if (route == "/shop/mul_add_food") {
        path = "/shop/food_admin";
      }
      if (route == "/shop/face_account_detail") {
        path = "/shop/face_account";
      }
      return path;
    }
  },
  created() {
    if (sessionStorage.getItem("accountInfo")) {
      let accountInfo = JSON.parse(sessionStorage.getItem("accountInfo"));
      if (
        accountInfo.account_type == 3 ||
        accountInfo.account_type == 2 ||
        accountInfo.account_type == 1
      ) {
        let routeMenuList = getRouterMenuList();
        this.menuList = routeMenuList;
        this.$root.eventHub.$emit("menuList", routeMenuList);
      } else {
        this.$message.error("权限不足，请重新登录");
        this.$router.push({ name: "Login" });
      }
    } else {
      this.$message.error("登录身份失效,请重新登录！");
      this.$router.push({ name: "Login" });
    }
  },
  mounted() {
    this.$root.eventHub.$on("navRoutePath", data => {
      // 处理数据
      this.activeRoute = data;
    });
    this.$root.eventHub.$emit(
      "sideRoutePath",
      this.handleRoutes(this.$route.path)
    );
    this.activeRoute = this.handleRoutes(this.$route.path);
  }
};
</script>

<style lang='scss'>
.layout-aside {
  width: 221px;
  height: 100%;
  user-select: none;
  .el-menu-vertical-demo {
    height: 100%;
    background: #26292c;
    .el-submenu__title {
      color: #909399 !important;
    }
    .el-submenu__title:hover {
      background-color: #26292c !important;
    }
    .el-menu-item-group {
      background-color: #26292c !important;
    }
    .el-menu-item {
      color: #909399 !important;
    }
    .el-menu-item.is-active {
      border-left: 3px solid #2694ee;
      background: #383a3d;
      color: #2694ee !important;
    }
    .el-menu-item-group__title {
      padding: 0 !important;
    }
    .el-menu-item:focus,
    .el-menu-item:hover {
      outline: 0;
      background-color: #383a3d !important;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/layout/LayoutAside.vue